import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=26db1c38&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"
import style0 from "./delivery.vue?vue&type=style&index=0&id=26db1c38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26db1c38",
  null
  
)

export default component.exports